import React from 'react';
import {TimeInputElement} from 'types/documentTemplateElement';
import {DocumentTemplate} from '../../../types/documentTemplate';
import BaseInputProperties from './BaseInputProperties';

interface TimeInputPropertiesProps {
  element: TimeInputElement;
  template: DocumentTemplate;
  updateElement: (updatedElement: TimeInputElement) => void;
}

const TimeInputProperties: React.FC<TimeInputPropertiesProps> = ({
  element,
  template,
  updateElement,
}) => {
  return (
    <BaseInputProperties
      element={element}
      template={template}
      updateElement={updateElement}
      hidePlaceholder={true}
    />
  );
};

export default TimeInputProperties;
